import { Box, styled } from '@mui/material';

// Grid container for the dashboard cards
export const CardsGrid = styled(Box)(() => ({
	listStyle: 'none',
	padding: 0,
	paddingRight: '60px',
	margin: '0 auto',
	display: 'grid',
	gridTemplateColumns: 'repeat(1, 1fr)',
	gridTemplateRows: 'none',
	gap: '24px',
	width: '100%',
	maxWidth: '1400px',
	boxSizing: 'border-box',

	'@media (min-width: 768px)': {
		gridTemplateColumns: 'repeat(2, 1fr)',
		gap: '24px',
	},

	'@media (min-width: 1024px)': {
		gridTemplateColumns: 'repeat(3, 1fr)',
		gap: '32px',
	},

	'@media (min-width: 1400px)': {
		gridTemplateColumns: 'repeat(3, 1fr)',
		gap: '40px',
	},
}));

export const GlowingLine = styled(Box)(() => ({
	position: 'relative',
	width: '100%',
	maxWidth: '600px',
	height: '1px',
	margin: '0 auto',
	background: 'linear-gradient(90deg, transparent 0%, #4786FF 50%, transparent 100%)',
	borderRadius: '0.5px',
	
	'&::before': {
		content: '""',
		position: 'absolute',
		top: '-1.5px',
		left: '50%',
		transform: 'translateX(-50%)',
		width: '400px',
		height: '4px',
		background: 'linear-gradient(90deg, transparent 0%, rgba(71, 134, 255, 0.2) 50%, transparent 100%)',
		filter: 'blur(3px)',
		borderRadius: '2px',
	},
	
	'&::after': {
		content: '""',
		position: 'absolute',
		top: '-0.5px',
		left: '50%',
		transform: 'translateX(-50%)',
		width: '300px',
		height: '2px',
		background: 'linear-gradient(90deg, transparent 0%, rgba(71, 134, 255, 0.4) 50%, transparent 100%)',
		filter: 'blur(1px)',
		borderRadius: '1px',
	},
}));

export const DashboardContainer = styled(Box)(() => ({
	position: 'relative',
	
	'&::before': {
		content: '""',
		position: 'fixed',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		background: `
			radial-gradient(circle at 20% 50%, rgba(71, 134, 255, 0.03) 0%, transparent 50%),
			radial-gradient(circle at 80% 20%, rgba(71, 134, 255, 0.03) 0%, transparent 50%),
			radial-gradient(circle at 40% 80%, rgba(71, 134, 255, 0.03) 0%, transparent 50%)
		`,
		pointerEvents: 'none',
		zIndex: -1,
	},
}));